import { getJwt } from "util/cookie";
import { HttpResponseError } from "util/errors";

const BASE_URL = process.env.REACT_APP_BACKEND_ORIGIN;

export const get = async <T>(
  url: string,
  options: { useBaseUrl?: boolean } = { useBaseUrl: true },
): Promise<T> => {
  url = options.useBaseUrl ? `${BASE_URL}${url}` : url;
  const response = await fetch(url, {
    credentials: "include",
    headers: [["Authorization", `Bearer ${getJwt()}`]],
  });
  if (!response.ok) {
    throw new HttpResponseError(response.status);
  }
  return response.json();
};
